import {
  CUSTOMER_VISIBILITY_SETTINGS_PLACES,
  INITIAL_CUSTOMERS_TABLE_VISIBILITY_SETTINGS,
} from '@/components/CustomerDrawer/constants';

export const LEAD_VISIBILITY_SETTINGS_PLACES = {
  LEAD_TABLE: 'leadsTableVisibilitySettings',
  LEAD_BOARD: 'leadsVisibilitySettings',
  CALENDAR_EVENT_POPOVER: 'calendarEventPopoverVisibilitySettings',
  CALENDAR_CARD: 'calendarCardVisibilitySettings',
  APPOINTMENT_TABLE: 'appointmentTableVisibilitySettings',
}

export const LEAD_PROPERTIES = {
  UUID: 'uuid',
  NAME: 'name',
  EMAIL: 'email',
  LOCALE: 'locale',
  ASSIGNEE: 'assignee',
  COMMENTS: 'comments',
  PHONE: 'phone',
  PRIORITY: 'priority',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  APPOINTMENT_AT: 'appointmentAt',
  DEAL_SIZE: 'dealSize',
  LEAD_SOURCE: 'leadSource',
  MARKETING_CHANNEL: 'marketingChannel',
  MARKETING_SOURCE: 'marketingSource',
  MARKETING_CAMPAIGN: 'marketingCampaign',
  CUSTOMER_CREATED_AT: 'customerCreatedAt',
  CUSTOMER_MODIFIED_AT: 'customerModifiedAt',
  LATEST_APPOINTMENT_BRANCH: 'appointmentBranch',
  LATEST_APPOINTMENT_BRANCH_SERVICE: 'appointmentBranchService',
  LATEST_APPOINTMENT_SERVICE_TYPE: 'appointmentServiceType',
  STATUS: 'status',
  SOURCE: 'leadSource',
  NOTE: 'note',
  TITLE: 'title',
  CALL_TRACKING: 'call_tracking',
  RESULT: 'result',
  CUSTOMER_INTEGRATIONS: 'customerIntegrations',
  PRODUCT_GROUP: 'product_group',
}

export const CALENDAR_PROPERTIES = {
  APPOINTMENT_BRANCH: 'appointment:branch',
  APPOINTMENT_ATTENDEES: 'appointment:attendees',
  APPOINTMENT_TIME: 'appointment:time',
  APPOINTMENT_ADDRESS: 'appointment:address',
  APPOINTMENT_VIDEO_LINK: 'appointment:videoLink',
}

export const CALENDAR_CARD_PROPERTIES = {
  APPOINTMENT_LEAD: 'appointment:lead',
  APPOINTMENT_BRANCH: CALENDAR_PROPERTIES.APPOINTMENT_BRANCH,
  APPOINTMENT_TIME: CALENDAR_PROPERTIES.APPOINTMENT_TIME,
  APPOINTMENT_TASKS: 'appointment:tasks',
  APPOINTMENT_SERVICE_TYPE: 'appointment:serviceType',
  APPOINTMENT_ASSIGNEE: 'appointment:assignee',
  APPOINTMENT_VIDEO_LINK: CALENDAR_PROPERTIES.APPOINTMENT_VIDEO_LINK,
}

export const LEAD_DETAILS_FOOTER_PROPERTIES = [
  LEAD_PROPERTIES.MARKETING_CHANNEL,
  LEAD_PROPERTIES.MARKETING_SOURCE,
  LEAD_PROPERTIES.MARKETING_CAMPAIGN,
  LEAD_PROPERTIES.LEAD_SOURCE,
  LEAD_PROPERTIES.CUSTOMER_INTEGRATIONS,
  LEAD_PROPERTIES.CREATED_AT,
  LEAD_PROPERTIES.UPDATED_AT,
];


export const APPOINTMENT_PROPERTIES = {
  TIME: 'appointment:time',
  TITLE: 'appointment:title',
  BRANCH: 'appointment:branch',
  LEAD: 'appointment:lead',
  LEAD_SOURCE: 'appointment:lead_source',
  AGENT: 'appointment:agent',
  STATUS: 'appointment:status',
  SERVICE_TYPE: 'appointment:serviceType',
  CREATED_AT: 'appointment:createdAt',
  UPDATED_AT: 'appointment:updatedAt',
  PROJECT_CREATED_AT: 'appointment:projectCreatedAt',
  PROJECT_UPDATED_AT: 'appointment:projectUpdatedAt',
  CUSTOMER_CREATED_AT: 'appointment:customerCreatedAt',
  CUSTOMER_MODIFIED_AT: 'appointment:customerModifiedAt',
};

export const INITIAL_PROPERTY_VISIBILITY_SETTINGS = {
  shown: [
    LEAD_PROPERTIES.NAME,
    LEAD_PROPERTIES.STATUS,
    LEAD_PROPERTIES.EMAIL,
    LEAD_PROPERTIES.PHONE,
    LEAD_PROPERTIES.ASSIGNEE,
  ],
  hidden: [
    LEAD_PROPERTIES.UUID,
    LEAD_PROPERTIES.CREATED_AT,
    LEAD_PROPERTIES.UPDATED_AT,
    LEAD_PROPERTIES.PRIORITY,
    LEAD_PROPERTIES.LOCALE,
    LEAD_PROPERTIES.DEAL_SIZE,
    LEAD_PROPERTIES.MARKETING_CHANNEL,
    LEAD_PROPERTIES.SOURCE,
    LEAD_PROPERTIES.NOTE,
    LEAD_PROPERTIES.TITLE,
    LEAD_PROPERTIES.APPOINTMENT_AT,
    LEAD_PROPERTIES.PRODUCT_GROUP,
    LEAD_PROPERTIES.MARKETING_SOURCE,
    LEAD_PROPERTIES.MARKETING_CAMPAIGN,
    LEAD_PROPERTIES.CUSTOMER_CREATED_AT,
    LEAD_PROPERTIES.CUSTOMER_MODIFIED_AT,
    LEAD_PROPERTIES.LATEST_APPOINTMENT_BRANCH,
    LEAD_PROPERTIES.LATEST_APPOINTMENT_BRANCH_SERVICE,
    LEAD_PROPERTIES.LATEST_APPOINTMENT_SERVICE_TYPE,
    // LEAD_PROPERTIES.RESULT
  ],
};

export const INITIAL_APPOINTMENT_TABLE_VISIBILITY_SETTINGS = {
  shown: [
    APPOINTMENT_PROPERTIES.TIME,
    APPOINTMENT_PROPERTIES.TITLE,
    APPOINTMENT_PROPERTIES.BRANCH,
    APPOINTMENT_PROPERTIES.LEAD,
    APPOINTMENT_PROPERTIES.AGENT,
    APPOINTMENT_PROPERTIES.STATUS,
  ],
  hidden: [
    APPOINTMENT_PROPERTIES.SERVICE_TYPE,
    APPOINTMENT_PROPERTIES.LEAD_SOURCE,
    APPOINTMENT_PROPERTIES.CREATED_AT,
    APPOINTMENT_PROPERTIES.UPDATED_AT,
    APPOINTMENT_PROPERTIES.PROJECT_CREATED_AT,
    APPOINTMENT_PROPERTIES.PROJECT_UPDATED_AT,
    APPOINTMENT_PROPERTIES.CUSTOMER_CREATED_AT,
    APPOINTMENT_PROPERTIES.CUSTOMER_MODIFIED_AT,
  ],
};

export const INITIAL_CALENDAR_EVENT_POPOVER_SETTINGS = {
  shown: [
    CALENDAR_PROPERTIES.APPOINTMENT_BRANCH,
    CALENDAR_PROPERTIES.APPOINTMENT_ADDRESS,
    CALENDAR_PROPERTIES.APPOINTMENT_TIME,
    CALENDAR_PROPERTIES.APPOINTMENT_ATTENDEES,
    LEAD_PROPERTIES.NOTE,
  ],
  hidden: [
    CALENDAR_PROPERTIES.APPOINTMENT_VIDEO_LINK,
    LEAD_PROPERTIES.EMAIL,
    LEAD_PROPERTIES.PHONE,
    LEAD_PROPERTIES.PRIORITY,
    LEAD_PROPERTIES.DEAL_SIZE,
    LEAD_PROPERTIES.MARKETING_CHANNEL,
    LEAD_PROPERTIES.MARKETING_SOURCE,
    LEAD_PROPERTIES.MARKETING_CAMPAIGN,
    LEAD_PROPERTIES.CUSTOMER_CREATED_AT,
    LEAD_PROPERTIES.CUSTOMER_MODIFIED_AT,
    LEAD_PROPERTIES.SOURCE,
    LEAD_PROPERTIES.TITLE,
    LEAD_PROPERTIES.PRODUCT_GROUP,
  ],
};

export const INITIAL_CALENDAR_EVENT_SETTINGS = {
  shown: [
    CALENDAR_CARD_PROPERTIES.APPOINTMENT_LEAD,
    CALENDAR_CARD_PROPERTIES.APPOINTMENT_TIME,
    CALENDAR_CARD_PROPERTIES.APPOINTMENT_SERVICE_TYPE,
    CALENDAR_CARD_PROPERTIES.APPOINTMENT_TASKS
  ],
  hidden: [
    CALENDAR_CARD_PROPERTIES.APPOINTMENT_BRANCH,
    CALENDAR_CARD_PROPERTIES.APPOINTMENT_ASSIGNEE,
    CALENDAR_CARD_PROPERTIES.APPOINTMENT_VIDEO_LINK,
    LEAD_PROPERTIES.EMAIL,
    LEAD_PROPERTIES.PHONE,
    LEAD_PROPERTIES.PRIORITY,
    LEAD_PROPERTIES.DEAL_SIZE,
    LEAD_PROPERTIES.MARKETING_CHANNEL,
    LEAD_PROPERTIES.MARKETING_SOURCE,
    LEAD_PROPERTIES.MARKETING_CAMPAIGN,
    LEAD_PROPERTIES.CUSTOMER_CREATED_AT,
    LEAD_PROPERTIES.CUSTOMER_MODIFIED_AT,
    LEAD_PROPERTIES.SOURCE,
    LEAD_PROPERTIES.NOTE,
    LEAD_PROPERTIES.TITLE,
    LEAD_PROPERTIES.PRODUCT_GROUP,
  ]
}
export const STATUS_MAGIC_PROPERTIES = [LEAD_PROPERTIES.DEAL_SIZE, LEAD_PROPERTIES.PRIORITY, LEAD_PROPERTIES.ASSIGNEE, LEAD_PROPERTIES.PHONE,
  LEAD_PROPERTIES.NOTE]

export const DEFAULT_VISIBILITY_SETTINGS = {
  [LEAD_VISIBILITY_SETTINGS_PLACES.LEAD_TABLE]: INITIAL_PROPERTY_VISIBILITY_SETTINGS,
  [LEAD_VISIBILITY_SETTINGS_PLACES.LEAD_BOARD]: INITIAL_PROPERTY_VISIBILITY_SETTINGS,
  [LEAD_VISIBILITY_SETTINGS_PLACES.CALENDAR_CARD]: INITIAL_CALENDAR_EVENT_SETTINGS,
  [LEAD_VISIBILITY_SETTINGS_PLACES.CALENDAR_EVENT_POPOVER]: INITIAL_CALENDAR_EVENT_POPOVER_SETTINGS,
  [LEAD_VISIBILITY_SETTINGS_PLACES.APPOINTMENT_TABLE]: INITIAL_APPOINTMENT_TABLE_VISIBILITY_SETTINGS,
  [CUSTOMER_VISIBILITY_SETTINGS_PLACES.CUSTOMERS_TABLE]: INITIAL_CUSTOMERS_TABLE_VISIBILITY_SETTINGS,
}
